import { render, staticRenderFns } from "./ForgottenPasswordForm.vue?vue&type=template&id=72981342&scoped=true"
import script from "./ForgottenPasswordForm.vue?vue&type=script&lang=ts"
export * from "./ForgottenPasswordForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72981342",
  null
  
)

export default component.exports